import React, { Component } from 'react'
import { connect } from 'react-redux'
import { openModal } from '../../../store/actions/Modais'

import { newExperience, experienceToApproval, experienceFind } from './_utils'

import '../../../v2SPRINTA/style.css'

import SlickSlider from '../../../v2SPRINTA/third-party/Slider'

import WhereAndWhat from './Steps/WhereAndWhat'
import HowWillItBe from './Steps/HowWillItBe'
import Details from './Steps/Details'   
// import Where from './Steps/Where'
import Title from './Steps/Title'
import Price from './Steps/Price'
import Midia from './Steps/Midia'
import BioProfile from './Steps/BioProfile'
import Observation from './Steps/Observation'
import Divider from './Divider'
import BoxAccordion from '../../../v2SPRINTA/atoms/BoxAccordion'
import Button from '../../../v2SPRINTA/atoms/Button'
import Display from '../../../v2SPRINTA/atoms/Display'
import { Col, Row, Container } from '../../../v2SPRINTA/atoms/Grid'
import ScrollTo, { calcDistanceElement, getPosition } from '../../../SPRINTA/atoms/ScrollTo'
import Loading from '../../../SPRINTA/atoms/Loading'
import FontIcon from '../../../SPRINTA/atoms/FontIcon'

import css from './style.css'
import ExperiencesList from './ExperiencesList';

import Institucional from './Institucional'
import Navigationbar from './NavigationBar';

class CreateExperience extends Component {
    cleanedData = {
        experience: {
            structure: []
        },
        address: {},
        profile: {},
        cover: null,
        images: []
    }

    state = {
        step: 1,
        steps: 8,
        token: null,
        status: null,
        errors: null,
        done: false,
        data: this.cleanedData,
        loadingDone: false,
        asyncMethods: 0
    }

    constructor(props) {
        super(props)
        this.step = {} 
    }

    verifyStep() {
        let step = 1
        for (let i = 1; i <= Object.keys(this.step).length; i++) {
            const element = this.step[i]
            if(element.inStep && element.inStep())
            step = i
        }

        this.setState({
            step
        })
    }

    newExperience() {

        if(!this.props.user.userData) {
            this.props.openModal('modal-login')
            return
        }

        this.setState({
            status: 'loading',
        })

        this.gotoForm()

        newExperience()
        .then(resp => {
            this.setState({
                status: 'done',
                errors: null,
                token: resp.token,
                data: this.cleanedData,
                done: false,
                step: 1,
            })
        })  
    }

    gotoForm() {
        let position = getPosition(this.refs.form)
        ScrollTo(position.y-150)
    }

    handleNextStep() {
        const { step, steps } = this.state

        let err = []
        for (let i = 1; i <= step; i++) {
            if(!this.step[i] || !this.step[i].validate) continue;
            
            let e = this.step[i].validate()
            
            if(e)
            err = [...err, ...e]
        }

        if(err.length > 0) {
            this.setState({
                errors: err
            })
            return 
        }
        
        if(step >= steps) {
            this.setState({
                loadingDone: true
            })
            experienceToApproval(this.state.token)
            .then(() => {
                this.setState({
                    done: true,
                    loadingDone: false
                }, () => {
                    this.props.history.push(`/create/gym/done/${this.state.token}`)
                })

            })
            return
        }

        let newStep = step + 1

        window.setTimeout(() => {
            let topDistance = calcDistanceElement(document.getElementById('step'+newStep))
            ScrollTo(topDistance-68)
        }, 300)

        
        this.setState({
            step: newStep,
            errors: null
        })
        
    }

    asyncMethod(async) {
        this.setState({
            asyncMethods: this.state.asyncMethods + 1
        })
        
        Promise.resolve(async)
        .then(() => {
            this.setState({
                asyncMethods: this.state.asyncMethods - 1
            })
        })
    }

    loadToContinue(token) {
        this.setState({
            status: 'loading'
        })
        
        this.gotoForm()

        experienceFind(token)
        .then(resp => {
            if(!resp.address) resp.address = {}
            if(!resp.profile) resp.profile = {}
            
            this.setState({
                status: 'done',
                errors: null,
                token,
                data: { ...this.cleanedData, ...resp },
                step: 1,
                done: false
            })
            this.verifyStep()
        })
    }

    setData(data, f) {
        this.setState({
            data: {
                ...this.state.data,
                ...data
            }
        }, () => {
            if(f) f()
        })
    }

    render() {
        return (
            <div>

                <Institucional />
                
                {this.props.user.userData && (
                    <ExperiencesList onContinue={token => this.loadToContinue(token)} />
                )}

                <div style={{backgroundColor: '#f9f9f9', padding: '60px 0', color: '#2b2b29' }}>
                    <Container style={{ paddingBottom: '30px' }}>
                        <Row justifyContent='center'>
                            <Col text='center' size='12'>
                                <Display size={2}>Cadastre sua academia e tenha mais clientes.</Display>
                                <br />
                                <Display size={3}></Display>
                            </Col>
                        </Row>
                    </Container>
                    <Container>
                        <Row>
                            <Col>
                                <SlickSlider>
                                    <Col className={css.listTopItem}>
                                        <span className={css.listIndicator}>
                                            <Display size={3}>1</Display>
                                        </span>
                                        {this.state.done && <span className={css.check}><FontIcon name='check-o' /></span> }
                                        <div className={css.listContent}>
                                            <Display size={3}><b>Leia</b> os padrões de qualidade</Display>
                                            <br />
                                            Antes de tudo, <a href='https://app.sprinta.com.br/user/sprinta?post_target=1695c59c9c1e460f' target='_blanck'>leia nossos padrões de qualidade.</a> <br /> Eles são vitais para que a sua academia seja oferecida dentro do SPRINTA.
                                        </div>
                                    </Col>
                                    <Col className={css.listTopItem}>
                                        <span className={css.listIndicator}><Display size={3}>2</Display></span>
                                        {this.state.done && <span className={css.check}><FontIcon name='check-o' /></span> }
                                        <div className={css.listContent}>
                                            <Display size={3}><b>Cadastre</b> suas atividades</Display>
                                            <br />
                                            Aumente sua receita vendendo acessos diários ou mensais e atraia novos alunos.<br />
                                        </div>
                                    </Col>
                                    <Col className={css.listTopItem}>
                                        <span className={css.listIndicator}><Display size={3}>3</Display></span>
                                        {this.state.done && <span className={css.check}><FontIcon name='check-o' /></span> }
                                        <div className={css.listContent}>
                                            <Display size={3}><b>Envie</b> para nós</Display>
                                            <br />
                                            Avaliaremos se sua academia se encaixa nos padrões de qualidade SPRINTA. 
                                        </div>
                                    </Col>
                                </SlickSlider>
                            </Col>
                        </Row>

                        <Row>
                            <Col text='center' size='12' style={{ marginTop: '30px' }}>
                                <Button
                                    primary
                                    inline
                                    onClick={() => this.newExperience() }>
                                    Cadastrar academia agora
                                </Button>
                            </Col>
                        </Row>
                    </Container>
                </div>

                { this.props.user.userData && (
                        <div ref='form'>
                            { this.state.status === 'loading' ? (
                                <div style={{ margin: '30px 0', width: '100%', float: 'left' }}>
                                <Loading />
                            </div>
                            ) : (
                                this.state.status === 'done' && (
                                    this.CreateEventRender()
                                )
                            ) }
                        </div>
                    )
                }
                
            </div>
        )
    }


    CreateEventRender() {
        let steps = {
            current: this.state.step,
            size: this.state.steps
        }
        return (
            <div>
                <WhereAndWhat
                    steps={{
                        ...steps,
                        self: 1
                    }}
                    ref={ref => this.step[1] = ref}
                    token={this.state.token}
                    async={item => this.asyncMethod(item)} 
                    data={this.state.data}
                    setData={(data, f) => this.setData(data, f)}
                />

                <div id='step2'>
                    <BoxAccordion show={this.state.step >= 2}>
                        <Divider />
                        <HowWillItBe
                            steps={{
                                ...steps,
                                self: 2
                            }}
                            ref={ref => this.step[2] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}  />
                    </BoxAccordion>
                </div>
            
                <div id='step3'>
                    <BoxAccordion show={this.state.step >= 3}>
                        <Divider />
                        <Details
                            steps={{
                                ...steps,
                                self: 3
                            }}
                            ref={ref => this.step[3] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}  />                        
                    </BoxAccordion>
                </div>
                {/* <div id='step4'>
                    <BoxAccordion show={this.state.step >= 4}>
                        <Divider />
                        <Where
                            steps={{
                                ...steps,
                                self: 3
                            }}
                            ref={ref => this.step[4] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)} />                        
                    </BoxAccordion>
                </div> */}

                <div id='step4'>
                    <BoxAccordion show={this.state.step >= 4}>
                        <Divider />
                        <Title
                            steps={{
                                ...steps,
                                self: 4
                            }}
                            ref={ref => this.step[4] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}  />                        
                    </BoxAccordion>
                </div>

                <div id='step5'>
                    <BoxAccordion show={this.state.step >= 5}>
                        <Divider />
                        <Midia
                            steps={{
                                ...steps,
                                self: 5
                            }}
                            ref={ref => this.step[5] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}  />                        
                    </BoxAccordion>
                </div>

                <div id='step6'>
                    <BoxAccordion show={this.state.step >= 6}>
                        <Divider />
                        <Price
                            steps={{
                                ...steps,
                                self: 6
                            }}
                            ref={ref => this.step[6] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}   />                        
                    </BoxAccordion>
                </div>
                <div id='step7'>
                    <BoxAccordion show={this.state.step >= 7}>
                        <Divider />
                        <Observation
                            steps={{
                                ...steps,
                                self: 7
                            }}
                            ref={ref => this.step[7] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}  />                        
                    </BoxAccordion>
                </div>

                <div id='step8'>
                    <BoxAccordion show={this.state.step >= 8}>
                        <Divider />
                        <BioProfile
                            steps={{
                                ...steps,
                                self: 8
                            }}
                            ref={ref => this.step[8] = ref}
                            token={this.state.token}
                            async={item => this.asyncMethod(item)}
                            data={this.state.data}
                            setData={(data, f) => this.setData(data, f)}  />                        
                    </BoxAccordion>
                </div>
                <Navigationbar
                    errors={this.state.errors}
                    loadingDone={this.state.loadingDone}
                    step={this.state.step}
                    steps={this.state.steps}
                    handleNextStep={() => this.handleNextStep()}
                    finish={`Cadastrar academia`}
                />
            </div>            
        )
    }
}

const mapStateToProps = store => ({
    user: store.user
})
const mapDispatchToProps = {
    openModal
}
export default connect( mapStateToProps, mapDispatchToProps )(CreateExperience)


// WEBPACK FOOTER //
// ./src/App/pages/CreateGym/index.js